import { useEffect } from 'react'
import { UserState } from '@/states'

const useBlur = () => {
    const { User } = UserState()

    useEffect(() => {
        const elements = document.querySelectorAll('#__next *:not(.ignore-blur)')

        if (!User?._id) {
            document.body.style.overflow = 'hidden'

            for (let i = 0; i < elements.length; i++) {
                const element = elements[i] as HTMLElement

                element.style.filter = 'blur(2px)'
                element.style.pointerEvents = 'none'
            }
        }

        else {
            document.body.style.overflow = 'auto'

            for (let i = 0; i < elements.length; i++) {
                const element = elements[i] as HTMLElement

                element.style.filter = ''
                element.style.pointerEvents = 'auto'
            }
        }
    }, [User])
}

export default useBlur
